export default '/pricing/payment';
